export default __webpack_public_path__ + "static/media/sponsor12.415fa75b.jpg";